import * as React from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  id: string;
  children: React.ReactNode;
  className?: string;
};

export default function FieldsLabel({ id, children, className }: Props) {
  return (
    <label
      htmlFor={id}
      className={twMerge(
        'mb-1 block text-sm font-semibold text-gray-900',
        className,
      )}
    >
      {children}
    </label>
  );
}
